import { useMemo } from "react";
import { getGroupedThumbnails } from "../../../classes/utils/Thumbnailsutils";

const useAlignDerivedData = ({
  instances,
  instancesByModality,
  selectedTwin,
}) => {
  const groupedThumbnailsStandard = useMemo(() => {
    if (!instances || !instancesByModality) return [];

    const normalizedInstances = {
      ...instances,
      sagittal_dx_instance_id:
        instances.sagittal_dx_instance_id?._id ||
        instances.sagittal_dx_instance_id,
      coronal_dx_instance_id:
        instances.coronal_dx_instance_id?._id ||
        instances.coronal_dx_instance_id,
    };

    return (
      getGroupedThumbnails(
        normalizedInstances,
        instancesByModality,
        null,
        false
      )?.filter(group => group.modality === "DX") || []
    );
  }, [instances, instancesByModality]);

  const allInstances = useMemo(() => {
    if (!groupedThumbnailsStandard) return [];

    const instancesList = [];
    const instancesSet = new Set();

    groupedThumbnailsStandard.forEach(modalityGroup => {
      modalityGroup.instances.forEach(instance => {
        const instanceId = instance._id || instance.id;
        if (!instancesSet.has(instanceId)) {
          instancesSet.add(instanceId);
          instancesList.push(instance);
        }
      });
    });

    return instancesList;
  }, [groupedThumbnailsStandard]);

  const selectedTwinName = useMemo(() => {
    if (!selectedTwin) return "";
    return selectedTwin[0]?.title || "";
  }, [selectedTwin]);

  const digitalTwinId = useMemo(() => {
    if (!selectedTwin) return null;
    return selectedTwin[0]?._id || null;
  }, [selectedTwin]);

  const selectedPlanId = useMemo(() => {
    if (!selectedTwin) return null;
    return selectedTwin[0]?.selected_plan || null;
  }, [selectedTwin]);

  const initialKeyParameters = useMemo(() => {
    if (!selectedTwin) {
      return [];
    }

    const keyParams = selectedTwin[0]?.key_parameters || [];
    return keyParams.map(param =>
      typeof param === "string" ? Number(param) : param
    );
  }, [selectedTwin]);

  return {
    groupedThumbnailsStandard,
    allInstances,
    selectedTwinName,
    digitalTwinId,
    initialKeyParameters,
    selectedPlanId,
  };
};

export default useAlignDerivedData;
